<template lang="pug">
  #app
    Header
    main.main
      transition(name="bottom-fade" mode="out-in")
        router-view
    Footer
    .bg(:class="{showed: config.bg}")
</template>
<script>

import { mapActions, mapState } from 'vuex'
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {
    Header,
    Footer,
  },
  computed: {
    ...mapState([
      'config'
    ])
  },
  methods: {
    ...mapActions([
      'setBg'
    ])
  },
  mounted(){
    setTimeout(() => {
      this.setBg(true)
    }, 1000)
  }
}
</script>

<style lang="scss">
.bg{
  background-color: rgba(#06172c, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0;
  transition: all 1s;
  &.showed{
    opacity: 1;
  }
}

</style>
